import { render, staticRenderFns } from "./CowEnvironment.vue?vue&type=template&id=1cb6a20a&"
import script from "./CowEnvironment.vue?vue&type=script&lang=js&"
export * from "./CowEnvironment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports